<template>
  <div class="offline-meeting-history-detail-template" theme>
    <div id="offline-meeting-history-detail-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'offline-meeting',
      parts: [
        {
          elem: '#offline-meeting-history-detail-content',
          htmlFile: 'history-detail'
        }
      ]
    }
  }
}
</script>
